import Vue from 'vue'
import { Validator } from 'vee-validate'
import ValidatorEn from 'vee-validate/dist/locale/en'
import ValidatorFr from 'vee-validate/dist/locale/fr'

switch (locale) {
  case 'fr':
    Validator.localize('fr', ValidatorFr);
    break;
  default:
    Validator.localize('en', ValidatorEn);
    break;
}

export default {
  methods: {
    $_(line) {
      return (lang) ? lang[line] || '' : '';
    },
  }
}



// WEBPACK FOOTER //
// ./src/Lang.mixin.js